import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// import './styles/spacing-debug.css'; // Add this import
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initDevErrorInstrumentation } from "./core/utils/devErrorInstrumentation";
import { initResizeObserverLoopErrorSuppression } from "./core/utils/resizeObserverLoopErrorSuppression";

initResizeObserverLoopErrorSuppression();
initDevErrorInstrumentation();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
